$shm_projects_catalog_head $shm_list_head
	title_uri \
	Title $mol_link
		uri <= title_uri
		title <= title
	add_content /
		<= Add
		<= Settings
	Controls $mol_view
		sub /
			<= Filter
